import { Box, SvgIcon, Typography } from "@mui/material";
import { SubstepTitleProps } from "./types.ts";
import { getStepperSizeConfig } from "./stepper-config.ts";

const CheckIcon = ({ size }: { size: number }) => {
  const iconSize = Math.max(12, size - 1); // Minimum 12px, or substep font size - 1
  return (
    <SvgIcon viewBox="0 0 18 18" sx={{ width: iconSize, height: iconSize }}>
      <path d="M6.75 11.25L4.5 9L3.75 9.75L6.75 12.75L14.25 5.25L13.5 4.5L6.75 11.25Z" fill="currentColor" />
    </SvgIcon>
  );
};

export function SubstepTitle({ substep, title, complete, active, onSubstepClick, stepperSize = 'md', navigable = true, highlightIncomplete = false }: SubstepTitleProps) {
  const sizeConfig = getStepperSizeConfig(stepperSize);
  const getTextColor = () => {
    if (!navigable) {
      return "#adb5bd"; // disabled/non-navigable color
    }
    if (highlightIncomplete && !complete) {
      return "#dc3545"; // text-danger equivalent (red)
    }
    if (active) {
      return "#212529"; // text-dark equivalent
    }
    if (complete) {
      return "#6c757d"; // text-muted equivalent
    }
    return "#adb5bd"; // text-light equivalent
  };

  const getCursorStyle = () => {
    return navigable ? "pointer" : "not-allowed";
  };

  const getCheckmarkColor = () => {
    if (active) {
      return "#198754"; // success color
    }
    return "#198754"; // text-muted equivalent
  };

  return (
    <Box
      onClick={() => {
        if (navigable) {
          onSubstepClick?.(substep);
        }
      }}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        padding: "4px 10px",
        borderRadius: 1,
        cursor: getCursorStyle(),
        opacity: navigable ? 1 : 0.6,
        "&:hover": {
          backgroundColor: navigable ? "rgba(0, 0, 0, 0.04)" : "transparent",
        },
      }}
    >
      {complete && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: getCheckmarkColor(),
          }}
        >
          <CheckIcon size={sizeConfig.substepFontSize} />
        </Box>
      )}
      <Typography
        variant="body2"
        sx={{
          fontSize: sizeConfig.substepFontSize,
          fontWeight: 500,
          lineHeight: `${sizeConfig.substepFontSize + 9}px`,
          letterSpacing: "0.2px",
          color: getTextColor(),
          fontFamily: "Inter, sans-serif",
        }}
      >
        {title}
      </Typography>
    </Box>
  );
}